import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import English from './language/english.json';


i18n
  .use(LanguageDetector) 
  .use(initReactI18next) 
  .init({
    resources: {
      english: {
        translation: English,
      },
    },
    fallbackLng: localStorage.getItem('i18nextLng') || 'english', 
    interpolation: {
      escapeValue: false, 
    },
partialBundledLanguages: true,   // helps when we overwrite bundles
    react: {
      useSuspense: false,            // recommended when loading async
    },
  });


export default i18n;
